// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","textBox":"App_textBox__F2y-y","download":"App_download__u8X5x"};